module.exports = __webpack_public_path__ + "img/BoConceptgif.8a9a063b.gif";